"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateFormRenderer = exports.templateConfirmRenderer = exports.fieldToLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _APInput = _interopRequireDefault(require("../components/common/APInput"));
var _APNumberInput = _interopRequireDefault(require("../components/common/APNumberInput"));
var _APSelect = _interopRequireDefault(require("../components/common/APSelect"));
var _APLabelWithText = _interopRequireDefault(require("../components/common/APLabelWithText"));
var _APCryptoAddressInputContainer = _interopRequireDefault(require("../components/common/APCryptoAddressInput/APCryptoAddressInputContainer"));
var _formValidations = require("./formValidations");
var _WhiteListedWithdrawAddressSelectContainer = _interopRequireDefault(require("../components/WhiteListedWithdrawAddressSelect/WhiteListedWithdrawAddressSelectContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var fieldToLabel = exports.fieldToLabel = function fieldToLabel(field) {
  return field.replace(/([a-z])([A-Z])/g, '$1 $2');
};
var noValidationFields = ['DestinationTagNumber', 'Comment', 'TemplateType'];
var templateFormRenderer = exports.templateFormRenderer = function templateFormRenderer(template, customClass, context) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    Product = _ref.Product,
    ProductSymbol = _ref.ProductSymbol,
    DecimalPlaces = _ref.DecimalPlaces;
  var verificationLevelConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return Object.keys(template).map(function (field) {
    var label = field === 'BankAccountName' ? context.t('Bank Name') : context.t(fieldToLabel(field));
    var validate = noValidationFields.includes(field) ? null : _formValidations.required;
    var type = field === 'TemplateType' ? 'hidden' : 'text';
    if (template[field] && template[field].indexOf('[') === 0) {
      var options = template[field].split(',').map(function (el) {
        var value = el.trim().replace(/[[\]]/g, '');
        return {
          value: value,
          label: value
        };
      });
      if (field === 'Country') {
        try {
          var parsedArray = JSON.parse(template[field]);
          options = parsedArray.map(function (el) {
            return {
              value: el.Code,
              label: el.Name
            };
          });
        } catch (e) {
          // do nothing
        }
      }
      return /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        key: field,
        name: field,
        customClass: customClass,
        "data-test": field,
        label: label,
        validate: [_formValidations.required],
        options: options
      });
    }
    if (field === 'ExternalAddress') {
      if (verificationLevelConfig.RequireWhitelistedAddress) {
        return /*#__PURE__*/_react["default"].createElement(_WhiteListedWithdrawAddressSelectContainer["default"], {
          key: field
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_APCryptoAddressInputContainer["default"], {
        productSymbol: Product || ProductSymbol,
        key: field,
        name: field,
        "data-test": field,
        customClass: customClass,
        label: label
      });
    }
    if (template[field] && field !== 'TemplateType') {
      return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        key: field,
        "data-test": field,
        label: "".concat(context.t(label), ":"),
        text: template[field],
        customClass: customClass,
        classModifiers: "template-info"
      });
    } else {
      if (field === 'DestinationTagNumber') {
        return /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
          key: field,
          type: "text",
          name: "DestinationTagNumber",
          label: context.t('Destination Tag Number'),
          decimalPlaces: 0,
          customClass: customClass,
          info: context.t('Please note that a destination tag may be required if you are withdrawing to an exchange or online wallet.'),
          allowBigNumber: true,
          validate: validate
        });
      }
      if (field.toLowerCase() === 'amount') {
        return /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
          key: field,
          type: "text",
          name: "Amount",
          labelInInput: Product || ProductSymbol,
          label: context.t("Amount of ".concat(Product || ProductSymbol)),
          decimalPlaces: DecimalPlaces,
          customClass: customClass,
          validate: [_formValidations.required, _formValidations.greaterThanZero]
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        key: field,
        name: field,
        "data-test": label,
        customClass: customClass,
        label: label,
        type: type,
        validate: validate
      });
    }
  });
};
var templateConfirmRenderer = exports.templateConfirmRenderer = function templateConfirmRenderer(template, values, classNames, context) {
  return Object.keys(template || {}).map(function (field) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      label: field === 'BankAccountName' ? context.t('Bank Name') : context.t(fieldToLabel(field)),
      key: field,
      "data-test": field,
      text: values[field],
      customClass: classNames()
    });
  });
};